import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

/* STYLES */
import "styles/globals.css";

/* ROUTES */
import Login from "pages/auth/login";
import Register from "pages/auth/register";
import ContactUs from "pages/dashboard/contact";

/* LAYOUT */
import Layout from "layout";

/* SCROLL TO TOP */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route element={<Login />} path="/" />
          <Route element={<Register />} path="/register" />
          <Route
            element={
              <Layout>
                <ContactUs />
              </Layout>
            }
            path="/contact-us"
          />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
